import { Directive, ElementRef, HostListener } from "@angular/core";
import { getCurrentDecimalSeperator } from "./utils";

@Directive({
	selector: "input[stripCommasAndDots]",
	standalone: false
})
export class StripDotsAndCommasDirectives {
	constructor(private _el: ElementRef) {}

	@HostListener("input", ["$event"]) onInputChange(event: Event): void {
		const precision = 2;
		const initialValue = this._el.nativeElement.value;
		const decimalSeperator = getCurrentDecimalSeperator();
		const split = initialValue.split(decimalSeperator);

		// if there are  more than 2 consecutive dots or commas, strip it
		if (split.length > precision) {
			const cut = initialValue.length - 1;
			this._el.nativeElement.value = initialValue.substring(0, cut);
			event.stopPropagation();
		}
	}
}
